import { motion } from "framer-motion";
import { fadeUp } from "../lib/motion";

const links = [
  { label: "Home", href: "#home" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Who It's For", href: "#who-its-for" },
  { label: "Proof", href: "#proof" },
  { label: "FAQ", href: "#faq" },
  { label: "Apply", href: "#apply" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-12 px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto border-t border-[#282930]"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <motion.div {...fadeUp} className="md:col-span-5">
          <h3 className="font-display text-2xl md:text-3xl text-[#F4EFE6]">
            Chadow <span className="italic text-[#C9A26B]">Marketing</span>
          </h3>
          <p className="mt-4 text-[#A8A39D] max-w-[40ch] leading-relaxed">
            Backend systems for creator-led businesses.
          </p>
          <p className="mt-6 text-xs text-[#A8A39D]/70 tracking-wide italic">
            Selective by design. Built for creators with traction.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="md:col-span-4">
          <p className="eyebrow text-[#A8A39D] mb-4">Navigate</p>
          <ul className="grid grid-cols-2 gap-y-2 gap-x-6">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-[#F4EFE6]/90 hover:text-[#C9A26B] transition-colors text-sm"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div {...fadeUp} className="md:col-span-3">
          <p className="eyebrow text-[#A8A39D] mb-4">Contact</p>
          <a
            href="mailto:hello@chadowmarketing.com"
            data-testid="footer-email"
            className="text-[#F4EFE6] hover:text-[#C9A26B] transition-colors text-sm break-all"
          >
            hello@chadowmarketing.com
          </a>
        </motion.div>
      </div>

      {/* Watermark */}
      <div className="relative mt-20 overflow-hidden">
        <div
          aria-hidden
          className="font-display select-none text-[#F4EFE6]/[0.04] leading-none tracking-tighter text-center"
          style={{ fontSize: "clamp(80px, 18vw, 280px)" }}
        >
          CHADOW
        </div>
      </div>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-[#1D1E24]">
        <p className="text-xs text-[#A8A39D]/70 tracking-wide">
          © {new Date().getFullYear()} Chadow Marketing. All rights reserved.
        </p>
        <p className="text-[10px] tracking-[0.22em] uppercase text-[#A8A39D]/70">
          You stay front-facing · We build behind the scenes
        </p>
      </div>
    </footer>
  );
};

export default Footer;
